import { Section } from "./PortalPage";
import { downloadAuthFile } from "../../lib/fileOpen";
import { fmtDate } from "./portalUtils";
import { HardHat, DownloadSimple, ShieldCheck } from "@phosphor-icons/react";

/** Issued RAMS for a client's job / emergency — download the branded PDF straight from the portal. Renders nothing until one is live. */
export function ClientRamsSection({ rams = [], kind, itemId, reference }) {
  if (!rams.length) return null;
  return (
    <Section title={<span className="flex items-center gap-1.5"><HardHat size={14} /> Health &amp; Safety — RAMS</span>} testid="client-rams-section">
      <p className="text-xs text-muted-foreground mb-3">Risk Assessment &amp; Method Statement issued for this work. Download it for your records or to share with site staff.</p>
      <div className="space-y-2">
        {rams.map((r) => (
          <button key={r.id} type="button"
                  onClick={() => downloadAuthFile(`/api/client-hub/${kind}/${itemId}/rams/${r.id}/pdf`, `${r.reference || "RAMS"}_v${r.version || 1}.pdf`)}
                  className="w-full flex items-center gap-3 border border-border rounded-md p-3 hover:bg-muted/40 text-left" data-testid={`client-rams-${r.id}`}>
            <ShieldCheck size={22} className="text-emerald-600 shrink-0" weight="duotone" />
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold truncate">{r.reference} · v{r.version || 1} — {r.title}</p>
              <p className="text-[10px] text-muted-foreground">
                Issued {r.issued_at ? fmtDate(r.issued_at) : "—"}{r.approved_by_name ? ` · approved by ${r.approved_by_name}` : r.prepared_by_name ? ` · prepared by ${r.prepared_by_name}` : ""}
                {r.crew_total ? ` · ${r.crew_briefed}/${r.crew_total} crew briefed` : ""}{r.review_date ? ` · review ${fmtDate(r.review_date)}` : ""}
              </p>
            </div>
            <DownloadSimple size={16} className="text-muted-foreground" />
          </button>
        ))}
      </div>
    </Section>
  );
}
